module.exports = __webpack_public_path__ + "img/kantar_ibope.caf3e224.svg";